<template>
    <div class="item">
        <div class="icon">
            <visual :svg="icon" />
        </div>
        <div class="caption">
            <heading :level="5">{{ title }}</heading>
            <cta
                v-bind="cta"
                is-link
                font-icon="fn_angleLink"
                size="XS"
                target="_blank"
                type="text"
                @click="track"
            />
        </div>
    </div>
</template>

<script>
import Cta from 'gvue/src/core/Cta'
import Heading from 'gvue/src/core/Heading'
import Visual from 'gvue/src/core/Visual'

import getImage from '@/helpers/image'

export default {
    name: 'ItemSchedule',
    components: {
        Cta,
        Heading,
        Visual
    },
    props: {
        stream: { type: Object, required: true }
    },
    computed: {
        icon() {
            const name = `social_${this.stream.type}`
            return getImage({ type: 'icon', name, landing: this.$landing })
        },
        title() {
            return this.config.streams[this.stream.type]
        },
        cta() {
            return {
                content: this.config.ctas.connect,
                link: this.stream.link
            }
        },
        config() {
            return this.$json.config
        }
    },
    methods: {
        track() {
            const dataLayer = window.dataLayer ? window.dataLayer : []
            dataLayer.push({
                event: 'customEvent',
                eventCategory: 'User Engagement',
                eventAction: 'Click link',
                eventLabel: 'Outbound link - ' + this.stream.link,
                nonInteraction: 0
            })
            /*
            event.preventDefault()
            window.open(this.link, '_blank')
            */
        }
    }
}
</script>

<style lang="sass" scoped>
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables
@import ScheduleItem
</style>
